module.exports = __webpack_public_path__ + "static/media/pp_clear_gaint_straw1.349a6189.png";